import ActionType from '../actions/types';

const initialState = {
  oauthToken: '',
  oauthTokenSecret: '',
  profileId: '',
  firstName: '',
  lastName: '',
  organizations: [],
  email: ''
};

export default function(state = initialState, action) {

  const {type, oauthToken, oauthTokenSecret, profileId, firstName, lastName, organizations, email} = action;

  switch (type) {
    case ActionType.STORE_REQUEST_TOKEN:
      return {
        ...state,
        oauthToken,
        oauthTokenSecret,
      };
    case ActionType.STORE_ACCESS_TOKEN:
      return {
        ...state,
        oauthToken,
        oauthTokenSecret,
        profileId,
      };
    case ActionType.SET_USER_INFO:
      return {
        ...state,
        firstName,
        lastName,
        organizations,
        email,
      };
    case ActionType.LOGOUT_USER:
      return initialState;
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js